import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
import { ImportDraftIdSchema, ImportSuggestionV1Schema } from "./import-draft.js";
import { BusinessGraphDraftViewV1Schema } from "./studio-project-workflow.js";
export const ImportSuggestionDecisionKindSchema = z.enum([
    "CONFIRMED",
    "REJECTED",
    "EDITED",
    "NEEDS_PROOF",
    "DEFERRED",
]);
export const ImportDraftReviewStatusSchema = z.enum([
    "PENDING_REVIEW",
    "IN_REVIEW",
    "PARTIALLY_REVIEWED",
    "REVIEW_COMPLETE",
    "APPLIED_TO_DRAFT",
]);
/** Per-suggestion agency decision with audit metadata. */
export const ImportSuggestionDecisionV1Schema = z
    .object({
    schemaId: z.literal("importSuggestion.decision.v1"),
    suggestionId: z.string().min(1),
    decision: ImportSuggestionDecisionKindSchema,
    editedValue: z.string().min(1).max(4096).optional(),
    decidedAt: z.string().datetime(),
    decidedByUserId: z.string().min(1).optional(),
    sourceRef: z.string().min(1),
    claimRisk: z.enum(["LOW", "MEDIUM", "HIGH"]).optional(),
})
    .strict();
export const SubmitImportSuggestionDecisionV1Schema = z
    .object({
    schemaId: z.literal("importConfirmation.submitDecision.v1"),
    suggestionId: z.string().min(1),
    decision: ImportSuggestionDecisionKindSchema,
    editedValue: z.string().min(1).max(4096).optional(),
})
    .strict();
export const SubmitImportSuggestionDecisionsRequestV1Schema = z
    .object({
    schemaId: z.literal("importConfirmation.submitDecisionsRequest.v1"),
    decisions: z.array(SubmitImportSuggestionDecisionV1Schema).min(1).max(100),
})
    .strict();
export const ImportSuggestionReviewItemV1Schema = z
    .object({
    suggestion: ImportSuggestionV1Schema,
    decision: ImportSuggestionDecisionV1Schema.optional(),
})
    .strict();
export const ImportDraftReviewViewV1Schema = z
    .object({
    schemaId: z.literal("importConfirmation.reviewView.v1"),
    importDraftId: ImportDraftIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema.optional(),
    sourceUrl: z.string().url(),
    extractionStatus: z.string().min(1),
    reviewStatus: ImportDraftReviewStatusSchema,
    items: z.array(ImportSuggestionReviewItemV1Schema),
    appliedDraftId: z.string().min(1).optional(),
    batchItemId: z.string().min(1).optional(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const ConfirmationQueueEntryV1Schema = z
    .object({
    importDraftId: ImportDraftIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema.optional(),
    sourceUrl: z.string().url(),
    reviewStatus: ImportDraftReviewStatusSchema,
    suggestionCount: z.number().int().min(0),
    pendingDecisionCount: z.number().int().min(0),
    batchItemId: z.string().min(1).optional(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const ConfirmationQueueListV1Schema = z
    .object({
    schemaId: z.literal("importConfirmation.queueList.v1"),
    entries: z.array(ConfirmationQueueEntryV1Schema),
})
    .strict();
export const ApplyConfirmedToDraftRequestV1Schema = z
    .object({
    schemaId: z.literal("importConfirmation.applyToDraftRequest.v1"),
    targetDraftId: z.string().min(1).optional(),
})
    .strict();
export const ApplyConfirmedToDraftResultV1Schema = z
    .object({
    schemaId: z.literal("importConfirmation.applyToDraftResult.v1"),
    importDraftId: ImportDraftIdSchema,
    appliedDraftId: z.string().min(1),
    reviewStatus: z.literal("APPLIED_TO_DRAFT"),
    draftView: BusinessGraphDraftViewV1Schema,
    appliedFieldCount: z.number().int().min(0),
})
    .strict();
//# sourceMappingURL=import-confirmation-queue.js.map